const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL ?? "").replace(/\/$/, "")

export const buildAttachmentUrl = (path?: string | null): string | null => {
  if (!path) {
    return null
  }

  if (/^https?:\/\//i.test(path)) {
    return path
  }

  const normalized = path.replace(/\\/g, "/").replace(/^\/+/, "")
  if (!normalized) {
    return null
  }

  const withPrefix = normalized.toLowerCase().startsWith("attachments/")
    ? normalized
    : `attachments/${normalized}`

  if (!API_BASE_URL) {
    return `/${withPrefix}`
  }

  return `${API_BASE_URL}/${withPrefix}`
}
